import styled, { css } from 'styled-components'
import { Link } from 'react-router-dom';

export const SC_Dropdown = styled.li.attrs(props => ({
	className: "nav-item dropdown",
}))`
	  
`

export const SC_DropdownToggle = styled.a.attrs(props => ({
	href: "#",
	className: "nav-link dropdown-toggle",
	role: "button",
	ariaHasPopup: true
}))`
	
`

export const SC_DropdownMenu = styled.div.attrs(props => ({
	className: "dropdown-menu",
}))`
	  
`

export const SC_DropdownItem = styled.a.attrs(props => ({
	className: "dropdown-item",
}))`
	display: flex;

	&>.icon-container {
		height: 23px;
		display: flex;
		align-items: center;
		margin-left: -${props => props.theme.inputBtnPaddingX};
	}	
`